import { useContext } from 'react'
import ShellRootContext from './ShellRootContext'

/* istanbul ignore next */
const useRootContext = () => useContext(ShellRootContext)

export default useRootContext
